import AnnotateDomainSequencesSettingsModal from 'antibodies/domain-annotation/AnnotateDomainSequencesSettingsModal';
import {DomainSequenceType} from 'antibodies/domain-annotation/DomainAnnotationTypes';
import startDomainSequenceAnnotation from 'antibodies/domain-annotation/startDomainSequenceAnnotation';
import {ListableItem} from 'search/SearchConstants';
import {ZINDEX_MODAL} from 'styles/StyleConstants';
import runModal from 'ui-library/runModal';
import * as ShortcutUtil from 'util/ShortcutUtil';

/**
 * Prompts for annotation settings and starts annotating the selected listing items. The items must already
 * pass `getDomainAnnotationDisabledReason`.
 */
export default async function annotateListingDomainSequences({
  items,
  sequenceType,
}: {
  items: Array<ListableItem>;
  sequenceType: DomainSequenceType;
}): Promise<void> {
  const config = await runModal(
    AnnotateDomainSequencesSettingsModal,
    {
      sequenceType,
      initialFolderId: ShortcutUtil.findCommonProjectFolderId(items, []),
      submitButtonText: 'Annotate',
      showAnnotationToggle: false,
    },
    {
      title: `Annotate ${sequenceType} domain entities`,
      size: 'lg',
      zIndex: ZINDEX_MODAL,
    }
  );
  if (config == null) {
    return;
  }
  startDomainSequenceAnnotation({sequenceIds: items.map((item) => item.id), config});
}
